	<p-toast></p-toast>
	<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
	<mat-tab-group #tabGroup [selectedIndex]="selectedIndex" (selectedIndexChange)="onIndexChange($event)">
		<mat-tab label="Properties">
			<app-properties-list [extSystemId]="extSystemId"></app-properties-list>
		</mat-tab>
		<mat-tab label="Reservations">
			<app-reservations-list></app-reservations-list>
		</mat-tab>
		<mat-tab label="Tape Charts">
			<app-tape-chart-list (doRedirectBulkUpdateCB)="onRedirectBulkUpdate($event)"></app-tape-chart-list>
		</mat-tab>
		<mat-tab label="Rate Buckets">
			<app-rateBuckets-list></app-rateBuckets-list>
		</mat-tab>
		<mat-tab label="Rate Seasons">
			<app-rateSeason-list></app-rateSeason-list>
		</mat-tab>
		<mat-tab label="Rate Seasons Summary">
			<app-rate-season-summary [propertyId]="propertyId" [propertyCode]="propertyCode"></app-rate-season-summary>
		</mat-tab>
		<mat-tab label="Rate Seasons Monthly Summary">
			<app-rate-season-monthly-summary [propertyId]="propertyId"></app-rate-season-monthly-summary>
		</mat-tab>
		<mat-tab label="Bulk Edit">
			<app-rate-detail-bulk-edit [rate]="rate" [updateBulkEdit]="updateBulkEdit"></app-rate-detail-bulk-edit>
		</mat-tab>
		<mat-tab label="Quality Test">
			<app-quality-test-list></app-quality-test-list>
		</mat-tab>
		<mat-tab label="Occ Matrix">
			<app-occ-days-matrix></app-occ-days-matrix>
		</mat-tab>
		<mat-tab label="Admin">
			<app-yieldmax-admin></app-yieldmax-admin>
		</mat-tab>
	</mat-tab-group>
